const toggleSelected = (arr, value) => {
    if (!arr.some(option => option.value === value)) {
        return arr;
    }

    return arr.map((item) => {
        if (item.value === value) {
            return { ...item, selected: true };
        }
        if (item.selected) {
            return { ...item, selected: false };
        }
        return item;
    });
};

const setSelectReducer = (categories, { type, value }) => ({
    ...categories,
    [type]: {
        ...categories[type],
        options: toggleSelected(categories[type].options, value),
    },
});

/**
 * When some option is changed we are using two reducers
 * (one that passed through props and one that change selected option)
 * to handle options transformations
 */
const updateCategories = (categories, reducer, action) =>
    setSelectReducer(reducer(categories, action), action);

export default updateCategories;



// WEBPACK FOOTER //
// ./src/js/shared/filter/helpers/updateCategories.js